export default __webpack_public_path__ + "static/media/menu-orange.28001fec.svg";